import { Brush, Edit, Link, RefreshCcw, Trash } from "lucide-react";
import { BatteryIcon } from "./DigitalTagBattery";
import { StatusChip } from "./DigitalTagStatusChips";
import DynamicButton from "./DymanicButton";
import moment from "moment";
import { SignalHigh, SignalMedium, SignalLow } from "lucide-react";
import Button from "@mui/material/Button";

const getSignalIcon = (rssi) => {
  if (rssi === null || rssi === undefined) {
    return <SignalLow color="gray" title="No Signal" />;
  }
  if (rssi >= -50) {
    return <SignalHigh color="green" title={`${rssi} dBm (Strong)`} />;
  } else if (rssi >= -70) {
    return <SignalMedium color="orange" title={`${rssi} dBm (Medium)`} />;
  } else {
    return <SignalLow color="red" title={`${rssi} dBm (Poor)`} />;
  }
};
export const processTableData = (data, path, handlers) => {
  const {
    handleEditClick,
    handleDeleteClick,
    handleLinkClick,
    refreshDigitalTags,
    handleApplyCollectionProfile,
  } = handlers;
  
  
  return data.map((item) => {
    const actions = [];
    let processedItem = { ...item };

    const { siteId, tenantId, ...restOfItem } = processedItem;

    processedItem = restOfItem;
  

    actions.push(
      <DynamicButton
        icon={Edit}
        color="warning"
        tooltip="Edit"
        onClick={() => handleEditClick(path, processedItem.id, processedItem)}
      />
    );
    actions.push(
      <DynamicButton
        icon={Trash}
        color="error"
        tooltip="Delete"
        onClick={() => handleDeleteClick(path, processedItem.id)}
      />
    );

    if (path === "digitalTag") {
      const {
        latitude,
        longitude,
        firewallVersion,
        ipAddress,
        gatewayId,
        protocol,
        lastSeen,
        customProperties,
        templateId,
        dynamicDataId,
        deviceType,
        createdAt,
        updatedAt,
        mac,
        product,
        screen,
        ver,
        type,
        tm,

        ...digitalTagData
      } = processedItem;

      let derivedStatus = "offline";
      if (tm) {
        const seenDate = new Date(tm);
        const today = new Date();
        if (
          seenDate.getFullYear() === today.getFullYear() &&
          seenDate.getMonth() === today.getMonth() &&
          seenDate.getDate() === today.getDate()
        ) {
          derivedStatus = "online";
        }
      }
      processedItem = {
        ...digitalTagData,
        canvasSize:
          typeof digitalTagData?.canvasSize === "object"
            ? digitalTagData?.canvasSize?.name ?? null
            : digitalTagData?.canvasSize ?? null, 
        canvasSizeId:
          digitalTagData?.canvasSizeId ??
          digitalTagData?.canvasSize?.id ??
          null,
        canvasColor:
          digitalTagData?.canvasColor && typeof digitalTagData?.canvasColor === "object"
            ? digitalTagData?.canvasColor?.name
            : digitalTagData?.canvasColor ?? null,
        canvasColorId:
          digitalTagData?.canvasColorId ??
          digitalTagData?.canvasColor?.id ??
          null,
        rotation: customProperties?.rotation ?? null,
        lastSeen: moment(tm).format("h:mm a, Do MM YYYY") || null,
      };

      actions.unshift(
        <DynamicButton
          icon={RefreshCcw}
          color="secondary"
          tooltip="Refresh"
          onClick={() =>
            refreshDigitalTags(item.tenantId, item.siteId, [item.id])
          }
        />
      );
      actions.unshift(
        <DynamicButton
          icon={Link}
          color="success"
          tooltip="Link Template"
          onClick={() =>
            handleLinkClick({
              tenantId: item.tenantId,
              siteId: item.siteId,
              ...digitalTagData,
            })
          }
        />
      );

      const row = {
        ...processedItem,
        status: <StatusChip value={derivedStatus} />,
        rssi: getSignalIcon(processedItem.rssi),
        battery: <BatteryIcon value={processedItem.battery} />,
        actions: actions,
      };

      Object.defineProperty(row, "canvasSizeId", {
        value: digitalTagData.canvasSizeId,
        enumerable: false,
      });

      Object.defineProperty(row, "canvasColorId", {
        value: digitalTagData.canvasColorId ?? digitalTagData?.canvasColor?.id,
        enumerable: false,
      });

      return row;
    }

    if (path === "gateways") {
      const {
        latitude,
        longitude,
        firewallVersion,
        ipAddress,
        ...gatewayData
      } = processedItem;

      processedItem = { ...gatewayData };
    }

    if (path === "collections") {
      return {
        ...processedItem,
        dataIds: (
          <>
            {processedItem.dataIds?.map((d) => (
              <Button
                key={d.id}
                size="small"
                disableElevation
                sx={{
                  m: 0.5,
                  minWidth: "auto",
                  px: 1.5,
                  py: 0.5,
                  borderRadius: "16px", 
                  textTransform: "none",
                  fontSize: "0.75rem",
                  fontWeight: 600,

                  color: "#fff",
                  background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",

                  "&:hover": {
                    background: "linear-gradient(90deg, rgb(58,130,150), rgb(63,88,111))",
                    opacity: 0.95,
                  },
                }}
              >
                {d.identifier}
              </Button>
            ))}
          </>
        ),
        actions: [
          <DynamicButton
            icon={Brush}
            color="info"
            tooltip="Apply Collection Profile"
            onClick={() => handleApplyCollectionProfile(processedItem.id)}
          />,
          ...actions,
        ],
      };
    }
    return {
      ...processedItem,
      actions: actions,
    };
  });
};
